import React from "react";
import SearchBar from "../../common/searchBar";
import Button from "@material-ui/core/Button";
import BlogMenubar from "./blogMenuBar";
const BlogNav = ({ value, handleSearch, user }) => {
  return (
    <div>
      {user && <BlogMenubar user={user}></BlogMenubar>}
      <div className={`d-flex justify-content-between ${!user && "pt-4 mt-1"}`}>
        <div>
          <SearchBar value={value} handleSearch={handleSearch}></SearchBar>
        </div>
        <div>
          <Button style={{ borderRadius: 50 }} size="small" variant="outlined">
            Create a blog
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BlogNav;
